import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import router from './router'
import axios from "axios";

Vue.use(Vuex)
Vue.use(VueResource)

const _api_url   = window.location.hostname.match(/localhost|192.168|10.0/g) ? `http://${window.location.hostname}:8081/api` : '/server/api';
const _rtapi_url = window.location.hostname.match(/localhost|192.168|10.0/g) ? `http://${window.location.hostname}:8081/rtapi` : '/server/rtapi';

const _axios = axios.create({
  baseURL: _api_url
})
_axios.defaults.params = {};
_axios.defaults.params['status'] = 'published';

const _rtaxios = axios.create({
  baseURL: _rtapi_url
})
_rtaxios.defaults.params = {};
_rtaxios.defaults.params['status'] = 'published';


export default new Vuex.Store({
  state: () => {
    return {
      http: _axios  ,
      rhttp: _rtaxios
    };
  },
  mutations: {
  },
  actions: {
    custom_get(context, payload) {
      return context.state.http.get(payload.url, {params: payload.params || {populate: 'true'}});
    },
    async get_token(context) {
      try {
        let response = await context.state.http.get('token');
        context.state.http.defaults.headers.common["X-API-KEY"] = response.data;
        context.state.rhttp.defaults.headers.common["X-API-KEY"] = response.data;
        return true;
      } catch (error) {
        return false;        
      }
    },
    async check_session(context) {
      try {
        let response = await context.state.http.get('checksession');
        if (response.data.error === false) {
          context.state.http.defaults.headers.common["X-LOGIN-KEY"] = response.data.token;
          context.state.rhttp.defaults.headers.common["X-LOGIN-KEY"] = response.data.token;
        }
        return response.data;
      } catch (error) {
        return false;        
      }
    },

    async get_cookie(context) {
      try {
        return await context.state.http.get('cookie');
      } catch (error) {
        return false;        
      }
    },

    async set_cookie(context) {
      try {
        return await context.state.http.get('acceptcookie');
      } catch (error) {
        return false;        
      }
    },


    async load(context, payload) {
      try {
        let _url = payload.mode || '/contributions';
        let response = {}
        if (payload.realtime) {
          response = await context.state.rhttp.get(_url, {params: payload.params || {populate: 'true'}});
        }
        else {
          response = await context.state.http.get(_url, {params: payload.params || {populate: 'true'}});
        }
        return response.data;
      } catch (error) {
        router.push("/404");
        return false;        
      }
    },
    async post(context, payload) {
      try {
        let response = await context.state.http.post(payload.mode, payload.params || {}, payload.headers || {});
        return response.data;
      } catch (error) {
        console.log(error)
        return false;        
      }
    }    
  }
})
